import React, { useEffect } from 'react';
import { Provider, useDispatch } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { App as AntdApp } from 'antd';
import store from './store';
import Layouts from './layouts';
import { THEME_CONFIG } from './configs/AppConfig';
import { bootRefresh } from './store/slices/authSlice';
import './lang';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

// Dispatches bootRefresh once on mount. Must live inside <Provider>.
function AppInitializer() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(bootRefresh());
  }, [dispatch]);
  return null;
}

function App() {
  if (process.env.NODE_ENV === "development") {
    const origWarn = console.warn;
    console.warn = (...args) => {
      if (
        typeof args[0] === "string" &&
        args[0].includes("React Router Future Flag Warning")
      ) return;
      origWarn(...args);
    };
  }

  return (
    <Provider store={store}>
      <BrowserRouter>
        <ThemeSwitcherProvider
          themeMap={themes}
          defaultTheme={THEME_CONFIG.currentTheme}
          insertionPoint="styles-insertion-point"
        >
          <AntdApp>
            <AppInitializer />
            <Layouts />
          </AntdApp>
        </ThemeSwitcherProvider>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
